import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { RouterModule } from '@angular/router'; // 👈 AJOUT
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SettingsComponent } from '../settings/settings.component';
import { FooterNavComponent } from '../footer-nav/footer-nav.component';
@Component({
  selector: 'app-disclaimer',
  standalone: true,
  imports: [SideNavComponent, CommonModule, TranslateModule, RouterModule, SettingsComponent, FooterNavComponent],
  templateUrl: './disclaimer.component.html',
})
export class DisclaimerComponent {
  lastUpdated = '17 août 2025';
  showFooterMenu = false;
  showSettings = false;
  headerHpx = 72; // fallback
  constructor(private translate: TranslateService) { }
  isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }
  toggleTheme() {
    const body = document.body;
    if (body.classList.contains('light-mode')) {
      body.classList.remove('light-mode');
      body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      body.classList.remove('dark-mode');
      body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
    }
  }
  get invBridgeGradient(): string {
    return  'bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700';
  }
  get invBridgeLogo(): string {
    return 'text-purple-500';
  }
  toggleSettings() {
    this.showSettings = !this.showSettings;
  }
  toggleFooterMenu() { this.showFooterMenu = !this.showFooterMenu; }
  closeFooterMenu() { this.showFooterMenu = false; }
  get selectedLanguage(): string {
    const l = this.translate.currentLang || localStorage.getItem('lang') || 'en';
    return l.toLowerCase();
  }
  /* swap.component.ts */
  onCurrencyChanged(code: string) {

    // Pas d’appel à fetchPrices / CoinGecko ici.
  }
}
